<template>
    <div class="container flex-center">
        <div class="container-box">
            <div class="container-head" style="font-size:16px!important;padding:15px 0;">
                深圳时代科技OA系统
                <!-- <img src="../assets/logo.png"/> -->
            </div>
            <el-form :model="loginForm" status-icon :rules="ruleInline" ref="loginForm" class="demo-ruleForm login-form" autocomplete="off">
                <el-form-item prop="userName">
                    <el-input v-model="loginForm.userName" type='text' name="userName" autocomplete="off"
                              placeholder="用户名" prefix-icon="icon iconfont icon-yonghu" class="login-input"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input v-model="loginForm.password" type="password" name="password" autocomplete="off"
                              placeholder="密码" prefix-icon="icon iconfont icon-mima" class="login-input"></el-input>
                </el-form-item>
                <div class="drag" ref="dragDiv">
                    <div class="drag_bg"></div>
                    <div class="drag_text">{{confirmWords}}</div>
                    <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;"></div>
                </div>
                <!-- <el-form-item class="login-form-item">
                    <el-checkbox v-model="checked" class="login-check">记住用户名和密码</el-checkbox>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="loginSubmitForm" class="login-button">{{btnText}}</el-button>
                    <!-- <el-button type="info" @click="resetLoginForm"   class="login-reset">重置</el-button> -->
                </el-form-item>
            </el-form>
        </div>
        
        <p class="beian"><a href="https://beian.miit.gov.cn/">粤ICP备20068775号</a></p>
    </div>
</template>
<script>
    import Auth from '../services/auth';
    import store from '../store/store';
    import md5 from 'js-md5';
    export default {
        name: 'login',
        data() {
            var validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入用户名'));
                } else {
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    callback();
                }
            };
            return {
                ip: '',
                checked: false,
                isBtnLoading: false,
                loginForm: {
                    userName: '',
                    password: ''
                },
                ruleInline: {
                    userName: [
                        {required: true, validator: validateName, trigger: 'blur'},
                        { min: 1, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
                    ],
                    password: [
                        {required: true, validator: validatePass, trigger: 'blur'},
                        { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
                    ],
                },
                beginClientX:0,           /*距离屏幕左端距离*/
                mouseMoveStata:false,     /*触发拖动状态  判断*/
                maxwidth:'',               /*拖动最大宽度，依据滑块宽度算出来的*/
                confirmWords:'拖动滑块验证',   /*滑块文字*/
                confirmSuccess:false           /*验证成功判断*/
            };
        },
        created() {
            //回车
            let that = this;
            document.onkeypress = function(e) {
            var keycode = document.all ? event.keyCode : e.which;
                if (keycode == 13) {
                    that.loginSubmitForm();// 登录方法名
                    return false;
                }
            };
            this.reqIp();
        },
        computed: {
            btnText() {
                
                return '登录';
            }
        },
        mounted() {
             this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
            document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
            document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn);

            this.redirect = this.$route.query.redirect ? this.$route.query.redirect : '/';
            // 如果已登录，跳转到redirect指向的页面
            // if (Auth.authenticated()) {
            //     this.$router.replace({
            //         path: this.redirect
            //     })
            // }

            // 有记住用户名密码，直接取出自动填入表单
            // var login = localStorage.getItem("login");
            // login = JSON.parse(login);
            // if (login) {
            //     this.checked = true;
            //     this.loginForm.userName = login.userName;
            //     this.loginForm.password = login.password;
            // }

            
        },
        methods: {
            reqIp(){
                var formData = {}
                this.postFn(this.$apis.getIpFromRequest, formData,(res)=>{
                    // console.log(res)
                    if(res.body.retCode == '0000'){
                        this.ip = JSON.parse(res.body.data).IP;
                    }
                })
            },
            resetLoginForm() {
                // console.log(this);
            this.$refs.loginForm.resetFields()
            },
            loginSubmitForm() {
                this.$refs['loginForm'].validate((valid) => {
                    if (valid) {
                        var login = {
                            "username": this.loginForm.userName,
                            "password": this.loginForm.password,
                        };
                        this.isBtnLoading = true;
                        this.getLogin(login);
                    } else {
                        return false;
                    }
                });
            },
           async getLogin(login) {
                if(this.confirmWords=='拖动滑块验证'){
                    this.$message({
                        message: '请拖动滑块验证',
                        type: 'warning'
                    });
                    return false
                }
                var login = {
                                'userPassword': this.loginForm.password,
                                'lastLoginIp': this.ip,
                                'lastLoginArea': 'China',
                            };
                // 存到本地存储
                var key = '32ADFED602DA49788188858BE1C99068';
                login.userPassword=md5(encodeURIComponent(login.userPassword+ key));
                // var sss=md5(encodeURIComponent(JSON.stringify(login)+key));
                var sss=encodeURIComponent(md5(JSON.stringify(login)+key));
                // localStorage.setItem("login", JSON.stringify(login));
                // var user = res.data.data;
                
               
                var param={
                request: {
                head: {
                sign: sss,
                referrerType: '01', //pc-01  h5-02
                requestTime: Date.parse(new Date()),
                userId:this.loginForm.userName,
                // userid:login.username,
                },
                body: login
               }
             }
                param = JSON.stringify(param);
                console.log(param);
                
                const ress=await this.$http.post('ttoa-ms/user/login',param);
                var res=ress.data.response;
                // console.log(res.body.List);
                console.log(res);            
                 if (res.body.retCode=='9000') {
                 this.$message.error(res.body.retMsg);
                 return ;
                 }else if(res.body.retCode=='0001'){
                 this.$message.error(res.body.retMsg);   
                 }else if(res.body.retCode=='0100'){
                 this.$message.error(res.body.retMsg);   
                 }else if(res.body.retCode=='9998'){
                 this.$message.error(res.body.retMsg);   
                 }else if(res.body.retCode=='9999'){
                 this.$message.error(res.body.retMsg);   
                 }
                 else if(res.body.retCode=='0000'){
                this.$message.success(res.body.retMsg);
                /* var formData={
                    userid:this.loginForm.userName,
                    passWord:this.loginForm.password,
                    sign:sss,
                };   */
                localStorage.setItem("mmm",JSON.stringify(res.body));
                localStorage.setItem("userids",res.head.userId);
                window.sessionStorage.setItem('sign', res.head.sign);
                this.$router.replace('/')
                 }
                // this.postFn(this.$apis.login, formData,(res)=>{
                //     console.log(res)
                //     localStorage.setItem("token", res.body.token);
                //     var menu=res.body.menuList;
                //     console.log(menu)
                //     store.commit('setMenu', menu);
                //     this.$router.replace('/');
                // })
                //登录
                // this.$router.replace('/');
                // this.$http.post(this.$apis.login, formData).then((res)=>{
                //     console.log(res)
                //     var res=res.data.response;
                //     if(res.body.RetCode=='0000'){
                //         localStorage.setItem("token", res.body.token);
                //         var menu=res.body.menuList;
                //         console.log(menu)
                //         store.commit('setMenu', menu);
                //         this.$router.replace('/');
                //     }
                // })
                 
                
                // this.$http.post('/login.json', formData).then((res) => {
                //     this.isBtnLoading = false;
                //     if (res.data.code == 0) {
                //         if (this.checked) {// 记住用户名密码
                //             var login = {
                //                 'username': this.loginForm.userName,
                //                 'password': this.loginForm.password
                //             };
                //             // 存到本地存储
                //             localStorage.setItem("login", JSON.stringify(login));
                //         } else {
                //             localStorage.removeItem("login");
                //         }
                //         var user = res.data.data;
                //         Auth.login(user.accessToken, user.baseInfo);
                //         this.$message.success('登录成功！');
                //         this.$router.push({path: this.redirect});
                //     } else {
                //         this.$alert(res.data.msg);
                //     }
                // })
            },
            //校验
            mousedownFn:function (e) {
                if(!this.confirmSuccess){
                    e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
                    this.mouseMoveStata = true;
                    this.beginClientX = e.clientX;
                }
            },        //mousedoen 事件
            successFunction(){
                //校验成功
                this.confirmSuccess = true
                this.confirmWords = '验证通过';
                if(window.addEventListener){
                    document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
                }else {
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
                }
                document.getElementsByClassName('drag_text')[0].style.color = '#fff'
                document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
                document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
            },                //验证成功函数
            mouseMoveFn(e){
                if(this.mouseMoveStata){
                    let width = e.clientX - this.beginClientX;
                    if(width>0 && width<=this.maxwidth){
                        document.getElementsByClassName('handler')[0].style.left = width + 'px';
                        document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
                    }else if(width>this.maxwidth){
                        this.successFunction();
                    }
                }
            },                   //mousemove事件
            moseUpFn(e){
                this.mouseMoveStata = false;
                var width = e.clientX - this.beginClientX;
                if(width<this.maxwidth){
                    document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
                    document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
                }
            }     
        },
    }
</script>
<style>
    html, body, .container {
        width: 100%;
        height: 100%;
        /*min-width:1000px;*/
    }

    .flex-center {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
    }

    @media (max-width: 768px) {
        .container-box {
            width: 90%;
            background: #fff;
            box-sizing: border-box;
        }

        .container-head {
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            height: 30px;
        }

        .login-input {
            width: 80% !important;
            height: 40px;
            margin-bottom: 26px;
            border-radius: 5px;
        }

        .login-button {
            width: 80%;
            height: 46px;
            margin-bottom: 30px !important;
            line-height: 0 !important;
            border-radius: 0 !important;
            border-color: #6296ea !important;
            background: #6296ea !important;
            font-size: 18px !important;
            letter-spacing: 4px;
            vertical-align: middle;
        }
        .login-reset{
            width: 20%;
            height: 40px;
            margin-bottom: 30px !important;
            line-height: 0 !important;
            border-radius: 0 !important;
            border-color: #6296ea !important;
            /* background: #6296ea !important; */
            font-size: 18px !important;
            letter-spacing: 4px;
            vertical-align: middle;
        }
    }

    @media (min-width: 768px) and (max-width: 1920px) {
        .container-box {
            width: 400px;
            background: #fff;
            box-sizing: border-box;
        }

        .login-input {
            width: 80% !important;
            height: 40px;
            margin-bottom: 26px;
            border-radius: 5px;
        }

        .container-head {
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            height: 30px;
        }

        .login-button {
            width: 80%;
            height: 46px;
            margin-bottom: 30px !important;
            line-height: 0 !important;
            border-radius: 0 !important;
            border-color: #6296ea !important;
            background: #6296ea !important;
            font-size: 18px !important;
            letter-spacing: 4px;
            vertical-align: middle;
        }
        .login-reset{
            width: 20%;
            height: 40px;
            margin-bottom: 30px !important;
            line-height: 0 !important;
            border-radius: 0 !important;
            border-color: #6296ea !important;
            /* background: #6296ea !important; */
            font-size: 18px !important;
            letter-spacing: 4px;
            vertical-align: middle;
        }
    }

    @media (min-width: 1920px) {
        .container-box {
            width: 536px;
            background: #fff;
            box-sizing: border-box;
        }

        .login-input {
            width: 80% !important;
            height: 50px;
            margin-bottom: 26px;
            border-radius: 5px;
        }

        .container-head {
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            height: 30px;
        }

        .login-button {
            width: 80%;
            height: 40px;
            margin-bottom: 30px !important;
            line-height: 0 !important;
            border-radius: 0 !important;
            border-color: #6296ea !important;
            background: #6296ea !important;
            font-size: 18px !important;
            letter-spacing: 4px;
            vertical-align: middle;
        }
        .login-reset{
            width: 20%;
            height: 46px;
            margin-bottom: 30px !important;
            line-height: 0 !important;
            border-radius: 0 !important;
            border-color: #6296ea !important;
            /* background: #6296ea !important; */
            font-size: 18px !important;
            letter-spacing: 4px;
            vertical-align: middle;
        }
    }

    .container .el-form-item__error {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 66%;
        left: 11%;
    }

    .container {
        position: relative;
        background: url("../assets/login-bg.png") no-repeat center center;
        background-size: 100% 100%;
    }

    .container .el-input__inner {
        height: 100%;
        line-height: 100%;
    }

    .login-check {
        width: 80% !important;
        color: #888;
        margin-bottom: 24px;
        text-align: left;
    }

    .container .el-form-item {
        margin-bottom: 0;
    }

    .login-form {
        /*height:70%;*/
    }


    .login-form-item {
        margin-bottom: 10px;
    }

    .container .el-form-item__content {
        height: 100%;
        line-height: 0;
        text-align: center;
        width:100%!important;
        margin-left:0!important;
    }

    .container .el-checkbox__inner {
        width: 24px;
        height: 24px;
    }

    .container .el-checkbox__label {
        font-size: 16px;
    }

    .container .el-checkbox__inner::after {
        width: 10px;
        height: 14px;
    }

    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px rgba(238, 238, 238, 1) inset;
        border: 1px solid #eee !important;
        border-radius: 4px;
    }
    /* 滑块 */
     .drag{
         margin:0 auto 20px;
        position: relative;
        background-color: #e8e8e8;
        width: 80%;
        height: 34px;
        line-height: 34px;
        text-align: center;
    }
    .handler{
        width: 40px;
        height: 32px;
        border: 1px solid #ccc;
        cursor: move;
    }
    .handler_bg{
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
    }
    .handler_ok_bg{
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center;
    }
    .drag_bg{
        background-color: #7ac23c;
        height: 34px;
        width: 0px;
    }
    .drag_text{
        position: absolute;
        top: 0px;
        width: 100%;text-align: center;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
        -o-user-select:none;
        -ms-user-select:none;
    }

    .beian{
        position: fixed;
        bottom: 10px;
    }
    a{
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue